<template>
  <div class="table_box">
    <!-- {{ queryData }} -->
    <el-table class="table" 
      :data="tableData" 
      :highlight-current-row="highlightCurrentRow" 
      style="width: 100%" 
      :height="TableHeight" 
      ref="tableg" 
      @current-change="currentChange" 
      :row-class-name="tableRowClassName"
      @selection-change="selectChange">
      <el-table-column
        v-if="ISChangeCheckout"
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column 
        v-for="item in tableHeaderComputed"
        :key="item.prop" 
        :prop="item.prop"
        :label="item.label"
        :width="item.width || 'auto'"
        :min-width="item.minWidth || 'auto'"
        :show-overflow-tooltip="true"
        :render-header="renderHeader"
      >
        <template slot-scope="scope">
          <span class="nowrap nowrap-block" v-if="item.prop != 'operation' && item.prop != 'recordss' && !edit" v-html="scope.row[item.prop]" :title="scope.row[item.prop]"></span>

          <div v-else-if="edit">
            <div v-if="item.prop === 'stationName' && queryData.professionId !== 8">
              <el-select v-model="scope.row.stationAddId" @change="$emit('operation','stationIdChange', scope.row, scope.$index)" size="mini">
                <el-option v-for="option in tableData" :label="option.stationName" :value="option.stationId" :key="option.stationId"></el-option>
              </el-select>
            </div>
            <div v-else-if="item.prop === 'leaderFlagName' && scope.row[item.prop]  !== '队长'" @click="$emit('operation','addRemoveStudent', scope.row)" style="color: blue; cursor: pointer;">
              {{ scope.row.playerName ? $t('table.QC') : $t('table.TJ') }}
            </div>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </div>

          <div class="btn-box" v-else-if="item.prop == 'operation'">
            <!--   0!=  1== 2<= 3>=    -->
            <el-button v-for=" bs in item.SlotType.buttons" :key="bs.emitName" v-show="
              bs.isShow ?
                bs.isShow[1] == 0 ? scope.row[bs.isShow[0]] != bs.isShow[2] ? true : false :
                bs.isShow[1] == 1 ? scope.row[bs.isShow[0]] == bs.isShow[2] ? true : false :
                bs.isShow[1] == 2 ? scope.row[bs.isShow[0]] <= bs.isShow[2] ? true : false :
                bs.isShow[1] == 3 ? scope.row[bs.isShow[0]] >= bs.isShow[2] ? true : false : false
              : true "
              :disabled="!!scope.row.disabled"
              v-auth="bs.auth ? bs.auth : false"
              @click="$emit('operation',bs.emitName,scope.row)" 
              :type="bs.buttonType ? bs.buttonType : 'text'" 
              :style="{color: bs.color ? bs.color : ''}" 
              size="mini" v-text="bs.name" 
              :class="bs.className ? bs.className : ''"></el-button>
          </div>
        </template>
      </el-table-column>
      <!-- null 列表 -->
      <div slot="empty" class="empty_material">
        <img src="@/assets/image/default.png" :alt="$t('table.JZSB')" /> <p>{{$t('table.ZWSJ')}}</p>
      </div>
    </el-table>
  </div>
</template>
<script>
const userTypes = {
  0: 'admin',
  1: 'teacher',
  2: 'student'
}
const prodIsFrees = {
  0: 'pro',
  1: 'free'
}
export default {
  name: 'c-table',
  props:{
    tableData:{
      // 表格数据
      type: [Array],
      default:function(){
        return []
      }
    },
    avtiveList:{
      // 表格数据
      type: [Array],
      default:function(){
        return []
      }
    },
    tableHeader: {
      // 表格头部
      type:[Array,Object],
      default:function(){
        return []
      }
    },
    // 调用标识
    tableStr: [String],
    // 是否为编辑状态
    edit:[Boolean],
    TableHeight:{
      // 表格高度
      type: [String],
      default: '100%'
    },
    ISChangeCheckout:{
      // 是否显示 checkout
      type: [Boolean],
      default: true
    },
    highlightCurrentRow:{
        // 是否单选
      type: [Boolean],
      default: true
    }
  },
  computed:{
    tableHeaderComputed(){
      return this.tableHeader.filter(item=>{
        if(item.auth?.length){
          let { userType,prodIsFree } = this.__userData 
          let { isSys } = JSON.parse(sessionStorage.getItem('queryData'))
          let userTypeEmen =  userTypes[userType] === 'admin' ? isSys == 1 ? 'teacher' : 'admin' : userTypes[userType] // 当前用户类型
          let proIsFree = item.auth[1] // 是否需要免费付费
          if(!item.auth[0].includes(userTypeEmen)){
            // 用户权限没有
            return false
          }else if(typeof proIsFree === 'string' ? proIsFree !== prodIsFrees[prodIsFree] : false){
            // 免费与收费 
           return false
          }
          return true
        }else{
          return true
        }
      })
    },
    queryData(){
      return JSON.parse(sessionStorage.getItem('queryData'))
    }
  },
  methods: {
      selectChange(data){
        this.$emit('operation','selectChange',data, this.tableStr)
      },
      currentChange(data){
          this.$emit('operation','currentChange',data)
      },
      tableRowClassName({rowIndex}) {
        if(rowIndex % 2 === 0){
          return 'background-row'
        }
        return '';
      },
      selectTable(vals){
        this.$refs.tableg.clearSelection()
        vals.forEach(row => {
          this.$refs.tableg.toggleRowSelection(row);
        });
      },
      renderHeader(h, data) {
        return h("span", [
          h(
            "el-tooltip",
            {
              attrs: {
                class: "item",
                effect: "dark",
                content: data.column.label,
                placement: "top",
              },
            },
            [h("span", data.column.label)]
          ),
        ]);
    },
  },
}
</script>
<style scoped lang="scss">
.table_box{
  height: 100%;
}
.table {
  // border: 1px solid #f4f4f4;
  width: 10px;
  border-radius: 5px;
  /deep/ .el-table__row{
    height: 40px;
  }
  /deep/ .background-row{
    background-color: #F6F8FB;
  }
  /deep/ .cell {
    overflow:hidden; //超出的文本隐藏
    text-overflow:ellipsis; //溢出用省略号显示
    white-space:nowrap; //溢出不换行
    .btn-box{
      display: flex;
      gap: 10px;
      .el-button{
        margin: 0;
      }
    }
  }
  .empty_material{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    img{
      width: 30%;
    }
    p{ color: #ccc; margin: 0;}
  }
  .table_list{
    .el-icon-delete{
      color: red;
      cursor: pointer;
      display: inline-block;
      margin-left: 15px;
    }
  }
  }
  /deep/.el-table td{
    padding: 6px 0;
    border: none;
    
    font-size: 12px;
    font-family: Hiragino Sans GB;
    font-weight: normal;
    color: #0D141E;
  }
  /deep/.el-table th {
      font-weight: bold;
      color: #000;
  }
  /deep/ .el-table__body tr.current-row>td{
    background-color: #2cca2226;
  }

  /deep/ .el-table::before{
    height: 0;
  }
</style>
